module.exports = ".codigo {\n  max-width: 100px; }\n"